import {
  createReducer,
  updateObject,
  updateItemInArray,
} from 'helpers/ReducerUtil'
import {
  ADD_PANEL,
  REMOVE_PANEL,
  UPDATE_RESOLUTION_VALUE,
  UPDATE_SIZE_VALUE,
  UPDATE_VENDOR_VALUE,
  UPDATE_PART_NUMBER_VALUE,
  UPDATE_REFRESH_RATE_VALUE,
} from './constants'

const initialState = {
  panelVendorId: null,
  panelSizeId: null,
  panelResolutionId: null,
  panelRefreshRateId: null,
}

const updatePartNumber = (values, action) => {
  const { index, partNumber } = action
  return updateItemInArray(values, index, value => (
    updateObject(value, { partNumber })
  ))
}

const updatePanelSizeId = (values, action) => {
  const { index, panelSizeId, size } = action
  return updateItemInArray(values, index, value => (
    updateObject(value, { panelSizeId, size })
  ))
}

const updatePanelResolutionId = (values, action) => {
  const { index, panelResolutionId, width, height } = action
  return updateItemInArray(values, index, value => (
    updateObject(value, { panelResolutionId, width, height })
  ))
}

const updatePanelVendorId = (values, action) => {
  const { index, panelVendorId, vendorName } = action
  return updateItemInArray(values, index, value => (
    updateObject(value, { panelVendorId, vendorName })
  ))
}

const updatePanelRefreshRateId = (values, action) => {
  const { index, panelRefreshRateId, refreshRate } = action
  return updateItemInArray(values, index, value => (
    updateObject(value, { panelRefreshRateId, refreshRate })
  ))
}

const addPanel = (values, action) => [
  ...values, { ...initialState }
]

const removePanel = (values, action) => values.filter((val, index) => index !== action.index)

const panelReducer = createReducer([{ ...initialState }], {
  [ ADD_PANEL ]: addPanel,
  [ REMOVE_PANEL ]: removePanel,
  [ UPDATE_RESOLUTION_VALUE ]: updatePanelResolutionId,
  [ UPDATE_SIZE_VALUE ]: updatePanelSizeId,
  [ UPDATE_VENDOR_VALUE ]: updatePanelVendorId,
  [ UPDATE_PART_NUMBER_VALUE ]: updatePartNumber,
  [ UPDATE_REFRESH_RATE_VALUE ]: updatePanelRefreshRateId,
})

export default panelReducer
